import { useMemo } from 'react';
import { getNavigationForModule } from 'app/navigation';
import {
  APP_MODULE,
  APP_MODULES,
  isAdmin as IS_ADMIN,
  isIndustrial as IS_INDUSTRIAL,
  isManager as IS_MANAGER,
  isMonitoring as IS_MONITORING,
} from 'constants/module.constant';

export const useAppModule = () => {
  const navigation = useMemo(() => getNavigationForModule(APP_MODULE), []);

  return {
    module: APP_MODULE,
    modules: APP_MODULES,
    isMonitoring: IS_MONITORING,
    isIndustrial: IS_INDUSTRIAL,
    isManager: IS_MANAGER,
    isAdmin: IS_ADMIN,
    navigation,
  };
};
